import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

class StoreService {
  async list({ page = 0, limit = 10, search = '' } = {}) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.STORES.LIST, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async userList({ page = 0, limit = 10, search = '' } = {}) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.STORES.USER_LIST, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async create(payload) {
    try {
      const res = await axiosInstance.post(ENDPOINTS.STORES.CREATE, payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async update(uuid, payload) {
    try {
      const res = await axiosInstance.put(ENDPOINTS.STORES.UPDATE(uuid), payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async view(uuid) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.STORES.VIEW(uuid));
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async setStatus(uuid, isActive) {
    try {
      const res = await axiosInstance.put(
        ENDPOINTS.STORES.STATUS_UPDATE(uuid),
        { is_active: isActive }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async bulkUpload(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axiosInstance.post(ENDPOINTS.STORES.UPLOAD, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}

const storeService = new StoreService();
export default storeService;

